import './styles.scss';
import { addCpfMask, generateAvatarInitialsImage, MainButton } from '@repo/ui';
import React from 'react';
import { Card, CardBody, Col, Row } from 'reactstrap';
import { getEnv } from 'shared/get-env';

interface PersonData {
  id: string;
  photo?: string;
  name: string;
  cpf: string;
  profiles: {
    id: number;
    name: string;
  }[];
  activeGroups: number;
  radinos: number;
}

interface PersonListGridCardProps {
  dataViewMode: 'list' | 'grid';
  personData: PersonData;
  onNameClick: () => void;
  onViewProfileBtnClick: () => void;
}

export const PersonListGridCard = React.forwardRef<
  HTMLDivElement,
  PersonListGridCardProps
>(function PersonListGridCard(
  { dataViewMode = 'list', personData, onNameClick, onViewProfileBtnClick },
  ref,
) {
  const profiles = personData.profiles;
  const profilesNames = profiles.map((profile) => profile.name);
  return (
    <div className="col" ref={ref ? ref : null}>
      <Card className="team-box">
        {dataViewMode === 'grid' && (
          <div className="team-cover">
            <img
              src={getEnv('REACT_APP_ORGANIZATION_COVER_URL') || ''}
              alt="Cover do card da pessoa"
              className="img-fluid"
            />
          </div>
        )}
        <CardBody className="p-4">
          <Row className="align-items-center team-row">
            <Col className="col-lg-4 team-profile-img">
              <div className="mt-2">
                <img
                  src={
                    personData.photo ||
                    generateAvatarInitialsImage(personData.name, 36)
                  }
                  alt="Foto da pessoa"
                  className="avatar-lg object-fit-cover border border-4 rounded-circle border-success"
                />
              </div>
              <div className="team-content">
                <h5
                  className="fs-16 mb-1 cursor-pointer name-btn"
                  onClick={() => onNameClick()}
                >
                  {personData.name}
                </h5>
                <p className="text-muted mb-0">{addCpfMask(personData.cpf)}</p>
                <p className="text-muted mb-0">
                  {profiles.length > 5
                    ? profilesNames.slice(0, 5).join(', ') + '...'
                    : profilesNames.join(', ')}
                </p>
              </div>
            </Col>
            <Col className="col-lg-4">
              <Row className="text-center">
                <Col xs={6} className="border-end border-end-dashed">
                  <h5 className="mb-1">
                    {new Intl.NumberFormat('pt-BR').format(
                      personData.activeGroups || 0,
                    )}
                  </h5>
                  <p className="text-muted mb-0">Grupos Ativos</p>
                </Col>
                <Col xs={6}>
                  <h5 className="mb-1">
                    {new Intl.NumberFormat('pt-BR').format(
                      personData.radinos || 0,
                    )}
                  </h5>
                  <p className="text-muted mb-0">Radinos</p>
                </Col>
              </Row>
            </Col>
            <Col className="col-lg-2">
              <div className="d-flex justify-content-center align-items-center">
                <MainButton
                  color="light"
                  className="view-btn"
                  onClick={() => onViewProfileBtnClick()}
                >
                  Ver Perfil
                </MainButton>
              </div>
            </Col>
          </Row>
        </CardBody>
      </Card>
    </div>
  );
});
